// @ts-nocheck
import { Slash } from "@insite/mobius/Breadcrumbs";
import getColor from "@insite/mobius/utilities/getColor";
import { linkStyles } from "@store/Themes/common/mixins/link";
import breakpointValues from "@toolkit/Framework/Common/Utilities/breakpointValues";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import Styleguide from "@toolkit/Framework/Types/Styleguide";
import { siteWidthStyles } from "@toolkit/Themes/common/mixins";
import { css } from "styled-components";

const breadcrumbs: Styleguide["breadcrumbs"] = {
    defaultProps: {
        typographyProps: {
            color: "inherit",
            size: "inherit",
        },
        css: css`
            ${siteWidthStyles()}
            padding-top: ${pxToRem(16)};
            flex-wrap: wrap;

            ${x =>
                breakpointValues(
                    [x.theme.design.typography.size.smallest, x.theme.design.typography.size.smaller, null, null, null],
                    "font-size",
                )}

            ${Slash} {
                margin: 0 ${pxToRem(8)};
            }

            a {
                ${linkStyles("inherit", "text.linkAltHover", false, true)}
                /* Store Custom Code - Start */
                span {
                    font-weight: ${x => x.theme.design.typography.weight.base};
                }
                /* Store Custom Code - End */
            }

            [aria-current="page"] {
                color: ${getColor("text.disabled") /* Store Custom Code */};
                font-weight: ${x => x.theme.design.typography.weight.base /* Store Custom Code */};
            }
        `,
    },
};

export default breadcrumbs;
